















































































import {Vue, Component} from 'vue-property-decorator';
import SalesOrderService from '@/services/SalesOrderService';
import { SalesOrderDTO, SalesOrderFilters } from '@/dto/sales/orders/SalesOrderDTO';
import SimpleProfileSearch from "@/components/common/SimpleProfileSearch.vue";
import ProfileDTO from "@/dto/profile/ProfileDTO";
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import { CounterpartyType } from "@/constants/CounterpartyType";
import { debounce } from "typescript-debounce-decorator";
import CreateSalesOrderModal from "./CreateSalesOrderModal.vue";
import {processError} from "@/utils/ComponentUtils";
import RouteNames from "@/router/RouteNames";

@Component({
  components: {
    SimpleProfileSearch,
    PaginationComponent
  }
})
export default class SalesOrders extends Vue {
  private orders: SalesOrderDTO[] = [];
  private totalPages = 1;
  private selectedProfile: ProfileDTO | null = null;
  private RouteNames = RouteNames;
  private filters: SalesOrderFilters = {
    customerId: null,
    customerType: null,
    page: 0,
    size: 20
  };

  async mounted() {
    await this.loadOrders();
  }

  private openCreateModal() {
    (this as any).$modal.show(
      CreateSalesOrderModal,
      {
        onSuccess: () => this.loadOrders()
      },
      {
        height: 'auto',
        width: '600px',
        adaptive: true,
        clickToClose: false
      }
    );
  }

  async loadOrders() {
    this.$loadOn();
    try {
      const response = await SalesOrderService.getOrders(this.filters);
      this.orders = response.data.content;
      this.totalPages = response.data.totalPages;
    } catch (e) {
      processError(e, this);
    } finally {
      this.$loadOff();
    }
  }

  @debounce(500)
  private onFilterChange() {
    this.filters.page = 0;
    this.loadOrders();
  }

  private onProfileSelect(profile: ProfileDTO | null) {
    this.filters.customerId = profile ? profile.id : null;
    this.filters.customerType = profile ? (profile.type as unknown as CounterpartyType) : null;
    this.onFilterChange();
  }

  private onChangePage(page: number) {
    this.filters.page = page;
    this.loadOrders();
  }

  private formatCurrency(amount: number, currency: string): string {
    const symbol = currency === 'USD' ? '$' : currency + ' ';
    return `${symbol}${(amount / 100).toFixed(2)}`;
  }

  private formatDate(dateStr: string | null): string {
    if (!dateStr) return '—';
    const date = new Date(dateStr);
    return date.toLocaleString();
  }
}
